type OnboardingStorage = {
    getStorageItem(key: string): string | null;
    setStorageItem(key: string, value: string): void;
};

/** 统一表示 onboarding 阶段已经展示过的存储值。 */
const ONBOARDING_SEEN_VALUE = '1';

/** 安全读取 onboarding 阶段是否已经展示。 */
export function hasSeenOnboarding(storage: OnboardingStorage, key: string): boolean {
    try {
        return storage.getStorageItem(key) === ONBOARDING_SEEN_VALUE;
    } catch {
        return false;
    }
}

/** 安全记录 onboarding 阶段已经展示，存储异常不阻断业务。 */
export function markOnboardingSeen(storage: OnboardingStorage, key: string): void {
    try {
        storage.setStorageItem(key, ONBOARDING_SEEN_VALUE);
    } catch {
        // localStorage 不可用时只影响状态持久化，不影响当前页面功能。
    }
}
